/**
 * React Query hooks for recognition (message classification)
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { classifyMessageRange } from '@/api/recognition';
import { ClassifyRangeRequest, ClassificationResult } from '@/types/api';
import { getErrorMessage } from '@/api/client';

/**
 * Hook to classify message range
 * Note: API returns ClassificationResult[] directly, not ClassificationResponse
 */
export const useClassifyMessageRange = () => {
  const queryClient = useQueryClient();

  return useMutation<ClassificationResult[], Error, ClassifyRangeRequest>({
    mutationFn: classifyMessageRange,
    onSuccess: () => {
      // Invalidate messages cache after classification
      queryClient.invalidateQueries({ queryKey: ['messages'] });
    },
    onError: (error) => {
      console.error('Failed to classify messages:', getErrorMessage(error));
    },
  });
};

export default useClassifyMessageRange;
